VjsAdmin.DemoServersCreate = (function () {
    function init() {
        new Events();
    }

    let Events = VjsUtility.Controller.extend({
        btn: null,
        events: {
            'click .create-server': 'createServer',
        },
        createServer() {
            this.startLoadingButton();

            const req = new VjsUtility.Request();
            req.post('/api/demo-server/')
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully queued demo server.',
                        time: 4000,
                    });
                })
                .fail((x, h, r) => {
                    this.stopLoadingButton();
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    this.stopLoadingButton();
                });
        },
        startLoadingButton() {
            this.btn = $('.create-server');
            this.btn.text('Requesting...');
            this.btn.prop('disabled', true);
        },
        stopLoadingButton() {
            this.btn.text('Request Server');
            this.btn.prop('disabled', false);
        },
    });

    return {
        init,
    };
}());
